module.exports = __webpack_public_path__ + "img/accessory_item_14.2e319dbf.svg";